import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export type PositionsDrawerPositionsTab = "all" | "options" | "perps";

export const positionsDrawerPositionsTabAtom =
  atomWithStorage<PositionsDrawerPositionsTab>(
    "positionsDrawerPositionsTab",
    "all",
  );

export const usePositionsDrawerPositionsTab = () => {
  const [positionsDrawerPositionsTab, setPositionsDrawerPositionsTab] = useAtom(
    positionsDrawerPositionsTabAtom,
  );

  return {
    positionsDrawerPositionsTab,
    setPositionsDrawerPositionsTab,
  };
};
